import ContactInfo from "../../../../node_modules/@interness/web-core/src/content/legal/ContactInfo";
import InfoBlock from "../../../../node_modules/@interness/web-core/src/content/legal/InfoBlock";
import * as React from 'react';
export default {
  ContactInfo,
  InfoBlock,
  React
};